import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DeliveryOptionsEnum } from '@as-react/common-types';
import { Box, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { DeliveryPromiseMessage } from '../../../delivery-promise/DeliveryPromiseMessage';
import { makeGetBasketDeliveryInfoState, makeGetBasketDifferentDeliveryPromisesState, } from '../../../../redux/basket/selectors/BasketSelector';
import { useBasketOverviewConfig } from '../../../../context/ComponentConfigContext';
import { useFeatureToggle } from '../../../../hooks/useFeatureToggle';
import { isHomeDelivery } from '../../../../util/DeliveryPromiseUtil';
var DeliveryDateEnum;
(function (DeliveryDateEnum) {
    DeliveryDateEnum["HOURS"] = "H";
    DeliveryDateEnum["DAYS"] = "D";
    DeliveryDateEnum["WEEKS"] = "W";
})(DeliveryDateEnum || (DeliveryDateEnum = {}));
const NO_DELIVERY_MESSAGE = '0-0';
const testId = 'basket_delivery_promise';
const getDeliveryPromiseStatus = (hasCutoff, option, deliveryUnit) => {
    if (hasCutoff) {
        return 'direct';
    }
    if ([DeliveryOptionsEnum.NEXT_DAY, DeliveryOptionsEnum.NAMED_DAY].includes(option)) {
        return 'direct';
    }
    if ([DeliveryOptionsEnum.COLLECT_STORE, DeliveryOptionsEnum.COLLECT_HQ].includes(option) &&
        deliveryUnit === DeliveryDateEnum.HOURS) {
        return 'direct';
    }
    return 'delayed';
};
export const DeliveryPromise = ({ deliveryStoreName, isCheckoutFlowDisabled, handleChangeStore, hideEvoucherMessage, }) => {
    const { t } = useTranslation([I18N_NAMESPACES.buy, I18N_NAMESPACES.checkout, I18N_NAMESPACES.product]);
    const delivery_promise_standard_delivery_label = useFeatureToggle('delivery_promise_standard_delivery_label');
    const { totalMiniBlock } = useBasketOverviewConfig();
    const { delivery, deliveryMessages, deliveryUnit, hasEvoucher, requiresDelivery, deliveryPromiseCutoff } = useSelector(makeGetBasketDeliveryInfoState());
    const orderLinesHaveDifferentDeliveryPromises = useSelector(makeGetBasketDifferentDeliveryPromisesState());
    const getTitleForFallback = () => {
        const deliveryTime = delivery.split('-');
        let deliveryUnitTranslate = '';
        if (deliveryUnit) {
            switch (deliveryUnit) {
                case DeliveryDateEnum.HOURS:
                    deliveryUnitTranslate = t(`${I18N_NAMESPACES.product}:pdp.size.deliverypromise.txt.hours`);
                    break;
                case DeliveryDateEnum.DAYS:
                    deliveryUnitTranslate = t(`${I18N_NAMESPACES.product}:pdp.size.deliverypromise.txt.days`);
                    break;
                case DeliveryDateEnum.WEEKS:
                    deliveryUnitTranslate = t(`${I18N_NAMESPACES.product}:pdp.size.deliverypromise.txt.weeks`);
                    break;
                default:
                    deliveryUnitTranslate = '';
            }
        }
        return (t(`${I18N_NAMESPACES.product}:pdp.size.deliverypromise.txt`, {
            deliveryFrom: deliveryTime[0],
            deliveryTo: deliveryTime[1],
        }) +
            ' ' +
            deliveryUnitTranslate);
    };
    const getTitle = (key) => delivery_promise_standard_delivery_label
        ? `${t(`${I18N_NAMESPACES.buy}:buy.delivery.promise.` + key)}${deliveryMessages[key]}`
        : deliveryMessages[key];
    const getDeliveryText = () => orderLinesHaveDifferentDeliveryPromises && (totalMiniBlock === null || totalMiniBlock === void 0 ? void 0 : totalMiniBlock.deliveryTimeText) ? (_jsx(Box, { paddingBlockStart: "2", paddingInlineStart: "6", children: _jsx(TextAlpha, { children: totalMiniBlock === null || totalMiniBlock === void 0 ? void 0 : totalMiniBlock.deliveryTimeText }) })) : null;
    const deliveryPromiseCtaProps = deliveryStoreName && handleChangeStore
        ? {
            text: t(`${I18N_NAMESPACES.buy}:buy.delivery.promise.change.store`),
            prefix: `${deliveryStoreName} -`,
            onClick: handleChangeStore,
        }
        : undefined;
    if (isCheckoutFlowDisabled) {
        return (_jsxs(Box, { children: [_jsx(DeliveryPromiseMessage, { touchPoint: "pdp+basket", state: "unavailable", option: "ccSpecific", testId: testId, message: t(`${I18N_NAMESPACES.buy}:buy.delivery.promise.cannot.be.collected`), cta: deliveryPromiseCtaProps }), getDeliveryText()] }));
    }
    if (delivery === NO_DELIVERY_MESSAGE) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [!deliveryMessages && requiresDelivery && (_jsxs(Box, { children: [_jsx(DeliveryPromiseMessage, { touchPoint: "pdp+basket", state: "direct", option: "ccSpecific", testId: testId, message: getTitleForFallback(), cta: deliveryPromiseCtaProps }), getDeliveryText()] })), deliveryMessages &&
                requiresDelivery &&
                Object.entries(deliveryMessages).map(([deliveryOption, deliveryMessage]) => (_jsxs(Box, { children: [_jsx(DeliveryPromiseMessage, { touchPoint: "pdp+basket", state: getDeliveryPromiseStatus(Boolean(deliveryPromiseCutoff), deliveryOption, deliveryUnit), type: deliveryOption, option: isHomeDelivery(deliveryOption) ? 'hd' : 'ccSpecific', testId: testId, cutoff: deliveryPromiseCutoff, message: deliveryPromiseCutoff ? deliveryMessage : getTitle(deliveryOption), cta: deliveryPromiseCtaProps }), getDeliveryText()] }, deliveryOption))), hasEvoucher && !hideEvoucherMessage && (_jsx(DeliveryPromiseMessage, { touchPoint: "pdp+basket", state: "direct", option: "hd", testId: testId, message: t(`${I18N_NAMESPACES.checkout}:checkout.mailbox`) }))] }));
};
